import { cn } from '@/lib/utils';
import { Card, CardContent } from "@/components/ui/card";
import { RESPONSIVE, SPACING } from '@/design-system';
import { Skeleton } from "@/components/ui/skeleton";

export function UserCardSkeleton() {
  return (
    <Card className="overflow-hidden min-h-[180px] h-full">
      <CardContent className={cn(
        RESPONSIVE.paddingCardContentWide,
        SPACING.cardContent,
        SPACING.stackLg,
        'h-full flex flex-col'
      )}>
        {/* Avatar | Name | Action Icons */}
        <div className={cn(RESPONSIVE.gapResponsive, 'flex items-start')}>
          {/* Avatar */}
          <Skeleton className="w-14 h-14 sm:w-16 sm:h-16 rounded-lg flex-shrink-0" />
          
          {/* Name and details */}
          <div className={cn(SPACING.listItemGap, 'flex-1 min-w-0')}>
            <Skeleton className="h-4 sm:h-5 w-3/4" />
            <Skeleton className="h-3 sm:h-4 w-1/2" />
          </div>
          
          {/* Action icons */}
          <div className="flex gap-1 shrink-0">
            <Skeleton className="h-8 w-8 rounded-md" />
            <Skeleton className="h-8 w-8 rounded-md" />
          </div>
        </div>
        
        {/* Bio text */}
        <div className="space-y-1.5 flex-1">
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-4/5" />
          <Skeleton className={cn(RESPONSIVE.tabletUp, 'h-3 w-2/3')} />
        </div>
        
        {/* Tags/badges row */}
        <div className={cn(RESPONSIVE.flexRowCenterGap2, 'flex-wrap')}>
          <Skeleton className="h-5 w-16 rounded-full" />
          <Skeleton className="h-5 w-20 rounded-full" />
          <Skeleton className={cn(RESPONSIVE.tabletUp, 'h-5 w-14 rounded-full')} />
        </div>
      </CardContent>
    </Card>
  );
}
